import React from "react";
import "./style.scss";
import { useGetShippingPolicyDataQuery } from "../../../services/PrivacyPolicyAPI";
import Loader from "../fullPageLoader"


function Index() {
  const {
    data: aboutContent,
    error: contentError,
    isLoading: contentLoading,
  } = useGetShippingPolicyDataQuery();


  if (contentLoading) return <Loader />;
  if (contentError) return <p>Failed to load page content</p>;

  // Get the first section of the about content
  const aboutSection = aboutContent?.data;
  console.log("aboutSection", aboutSection)
  return (
    <>
      <section className="privacy-policy">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="mb-4">Shipping Policy</h1>

              <div
                dangerouslySetInnerHTML={{
                  __html: aboutSection.content,
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Index;
